/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidatePalNpiRequest
 */
export interface ValidatePalNpiRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidatePalNpiRequest
     */
    npi: string;
}

/**
 * Check if a given object implements the ValidatePalNpiRequest interface.
 */
export function instanceOfValidatePalNpiRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "npi" in value;

    return isInstance;
}

export function ValidatePalNpiRequestFromJSON(json: any): ValidatePalNpiRequest {
    return ValidatePalNpiRequestFromJSONTyped(json, false);
}

export function ValidatePalNpiRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatePalNpiRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'npi': json['npi'],
    };
}

export function ValidatePalNpiRequestToJSON(value?: ValidatePalNpiRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'npi': value.npi,
    };
}

